import React from 'react';
import styled from 'styled-components';
// import { GlobalSpinner } from '@app/components/common/GlobalSpinner/GlobalSpinner';
// import { useAppSelector } from '@app/hooks/reduxHooks';
// import { themeObject } from '@app/styles/themes/themeVariables';
import { ReactComponent as Spinner } from '@app/assets/icons/spinner.svg';

interface LoadingProps {
  size?: string;
  color?: string;
}

export const Loading: React.FC<LoadingProps> = ({}) => {
  // const theme = useAppSelector((state) => state.theme.theme);
  // const spinnerColor = color || themeObject[theme as keyof typeof themeObject].spinnerBase;

  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  );
};

const SpinnerContainer = styled.div`
  position: fixed;      /* detach from flow */
  top: 0;
  left: 0;
  width: 100vw;         /* full viewport width */
  height: 100vh;        /* full viewport height */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;        /* keep on top */
`;
